// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface FileVideoIconSignature {
  Element: SVGSVGElement;
}

export const FileVideoIcon: TOC<FileVideoIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.414 1.004H5C3.897 1.004 3 1.902 3 3.004V21.004C3 22.107 3.897 23.004 5 23.004H19C20.103 23.004 21 22.107 21 21.004V5.59L16.414 1.004ZM5 21.004V3.004H15V7.004H19L19.001 21.004H5ZM8 12.007H13V14.257L16 12.007V18.007L13 15.757V18.007H8V12.007Z"/>
</svg>
</template>;